import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import Translator from 'translator';
import memoizeOne from 'memoize-one';
import { Map } from 'immutable';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { withStyles, Tooltip, IconButton } from '@material-ui/core';
import { LinkOff as LinkOffIcon, RemoveRedEye as ViewIcon, People as PeopleIcon } from '@material-ui/icons';
import { FHETable, DetailPanelUsers } from 'data/components';
import { Toastr } from 'data/common';
import tools from 'data/common/tools';
import { dissociateSDM20LHTUser, dissociateSDM20LHTUserAndSwitchMaster } from '../../../data/SDM20LHT/actions';

class TableSDM20LHT extends PureComponent {
    static propTypes = {
        classes: PropTypes.object.isRequired,
        dissociateSDM20LHTUser: PropTypes.func.isRequired,
        dissociateSDM20LHTUserAndSwitchMaster: PropTypes.func.isRequired,
        SDM20LHTs: PropTypes.object.isRequired,
        history: PropTypes.object.isRequired,
        userId: PropTypes.number.isRequired,
        profile: PropTypes.object.isRequired
    };

    constructor(props) {
        super(props);
        this.state = {
            dissociateLoading: null
        };
    }

    /* NAVIGATION */
    navigateToDetail = rowData => {
        const { history } = this.props;
        return history.push({ pathname: `/${history.environment}/SDM20LHT/detail/${rowData.id}` });
    };

    navigateToUser = event => {
        const { history } = this.props;
        return history.push({
            pathname: `/${history.environment}/user/detail/${event.currentTarget.getAttribute('data-userid')}`
        });
    };

    /* ACTIONS */
    dissociateUser = SDM20LHTMac => {
        const { dissociateSDM20LHTUser, userId, history } = this.props;
        this.setState({ dissociateLoading: SDM20LHTMac });

        dissociateSDM20LHTUser(SDM20LHTMac, userId)
            .then(() => {
                Toastr.success(Translator.translate(`general.products.SDM20LHT.table.action.dissociate.success`));
            })
            .catch(err => {
                Toastr.error(
                    Translator.translateWithFallback(`socket.error.${err.message ? err.message : err}`, 'socket.error.defaultError'),
                    Translator.translate(`general.products.SDM20LHT.table.action.dissociate.error`)
                );
            })
            .finally(() => {
                this.setState({ dissociateLoading: null });
            });
    };
    dissociateMaster = SDM20LHTMac => {
        const { dissociateSDM20LHTUser, userId } = this.props;
        this.setState({ dissociateLoading: SDM20LHTMac });

        dissociateSDM20LHTUser(SDM20LHTMac, userId)
            .then(() => {
                Toastr.success(Translator.translate(`general.products.SDM20LHT.table.action.dissociate.success`));
            })
            .catch(err => {
                Toastr.error(
                    Translator.translateWithFallback(`socket.error.${err.message ? err.message : err}`, 'socket.error.defaultError'),
                    Translator.translate(`general.products.SDM20LHT.table.action.dissociate.error`)
                );
            })
            .finally(() => {
                this.setState({ dissociateLoading: null });
            });
    };
    dissociateMasterAndSwitch = (SDM20LHTMac, newMasterId) => {
        const { dissociateSDM20LHTUserAndSwitchMaster, userId } = this.props;
        this.setState({ dissociateLoading: SDM20LHTMac });

        dissociateSDM20LHTUserAndSwitchMaster(SDM20LHTMac, userId, newMasterId)
            .then(() => {
                Toastr.success(Translator.translate(`general.products.SDM20LHT.table.action.dissociate.success`));
            })
            .catch(err => {
                Toastr.error(
                    Translator.translateWithFallback(`socket.error.${err.message ? err.message : err}`, 'socket.error.defaultError'),
                    Translator.translate(`general.products.SDM20LHT.table.action.dissociate.error`)
                );
            })
            .finally(() => {
                this.setState({ dissociateLoading: null });
            });
    };
    dissociateProduct = rowData => {
        const { dissociateLoading } = this.state;
        const { userId } = this.props;
        if (dissociateLoading === rowData.id) return false;
        if (rowData.otherUsers.length === 0 && rowData.userMasterId === userId) {
            Toastr.confirm(
                Translator.translate(`general.products.SDM20LHT.table.action.dissociate.confirmRemoveMasterAlone`, rowData.macAddress),
                Translator.translate(`general.products.SDM20LHT.table.action.dissociate.confirmRemoveMasterTitle`),
                {
                    onYes: () => {
                        this.dissociateMaster(rowData.id);
                    }
                }
            );
        } else if (rowData.userMasterId === userId) {
            Toastr.select(
                Translator.translate(`general.products.SDM20LHT.table.action.dissociate.confirmRemoveMaster`, rowData.macAddress),
                Translator.translate(`general.products.SDM20LHT.table.action.dissociate.confirmRemoveMasterTitle`),
                rowData.otherUsers,
                {
                    onYes: newMasterId => {
                        this.dissociateMasterAndSwitch(rowData.id, parseInt(newMasterId));
                    }
                }
            );
        } else {
            Toastr.confirm(
                Translator.translate(`general.products.SDM20LHT.table.action.dissociate.confirmRemove`, rowData.macAddress),
                Translator.translate(`general.products.SDM20LHT.table.action.dissociate.confirmRemoveTitle`),
                {
                    onYes: () => {
                        this.dissociateUser(rowData.id);
                    }
                }
            );
        }
    };

    /* RENDER */
    renderData = memoizeOne(SDM20LHTs => {
        let result = [];

        SDM20LHTs.map(SDM20LHT => {
            result.push({
                id: SDM20LHT.get('macAddress'),
                macAddress: SDM20LHT.get('macAddress')
                    .match(/.{1,2}/g)
                    .join(':'),
                email: SDM20LHT.get('userEmail'),
                label: SDM20LHT.get('label'),
                switchState1: SDM20LHT.get('switchState1'),
                switchState2: SDM20LHT.get('switchState2'),
                relayType: SDM20LHT.get('relayType'),
                mode: Translator.translate(`general.data.mode.${SDM20LHT.get('mode')}`),
                state: SDM20LHT.getIn(['state'], false) ? Translator.translate(`general.${SDM20LHT.get('state')}`) : null,
                firmwareVersion: SDM20LHT.get('firmwareVersion'),
                usersList: SDM20LHT.get('usersList'),
                otherUsers: SDM20LHT.get('otherUsers'),
                userMasterId: SDM20LHT.get('userMasterId')
            });
        });
        return result;
    });

    renderActions = memoizeOne(profile => {
        const { history } = this.props;
        const userRights = profile.getIn(['user_rights', history.environment], []);

        let actions = {
            row: [
                {
                    icon: LinkOffIcon,
                    onClick: this.dissociateProduct,
                    tooltip: Translator.translate(`general.products.SDM20LHT.table.action.dissociate.tooltip`)
                }
            ],
            toolbar: []
        };
        if (profile.get('admin') || userRights.includes('SDM20LHTDetails')) {
            actions.row.push({
                icon: ViewIcon,
                onClick: this.navigateToDetail,
                tooltip: Translator.translate(`general.showDetail`)
            });
        }
        return actions;
    });

    renderDetails = memoizeOne(() => {
        return {
            renderToggleCell: ({ row, onToggle }) => {
                return (
                    <Tooltip title={Translator.translate('general.table.button.showUserList')} disableHoverListener={!row.userMasterId}>
                        <span>
                            <IconButton onClick={onToggle} disabled={!row.userMasterId}>
                                <PeopleIcon />
                            </IconButton>
                        </span>
                    </Tooltip>
                );
            },
            renderPanel: ({ row }) => {
                return <DetailPanelUsers usersList={row.usersList} userMasterId={row.userMasterId} onClick={this.navigateToUser} />;
            }
        };
    });

    renderColumns = memoizeOne(profile => {
        const { classes, history } = this.props;

        return [
            {
                title: Translator.translate('general.table.column.macAddress'),
                name: 'macAddress',
                width: 150,
                customFilter: tools.filterMacAddress
            },
            {
                title: Translator.translate('general.table.column.label'),
                name: 'label',
                action: (profile.get('admin') || profile.getIn(['user_rights', history.environment], []).includes('SDM20LHTDetails')) && {
                    onClick: this.navigateToDetail,
                    tooltip: Translator.translate(`general.showDetail`)
                }
            },
            {
                title: Translator.translate('general.table.column.email'),
                name: 'email'
            },
            {
                title: Translator.translate('general.table.column.switchState1'),
                name: 'switchState1'
            },
            {
                title: Translator.translate('general.table.column.switchState2'),
                name: 'switchState2'
            },
            {
                title: Translator.translate('general.table.column.relayType'),
                name: 'relayType'
            },
            {
                title: Translator.translate('general.table.column.mode'),
                name: 'mode'
            },
            {
                title: Translator.translate('general.table.column.state'),
                name: 'state',
                render: (row, data, value) => {
                    if (!value) return null;
                    return (
                        <span className={value === Translator.translate('general.connected') ? classes.connected : classes.disconnected}>
                            {value}
                        </span>
                    );
                }
            },
            {
                title: Translator.translate('general.table.column.firmwareVersion'),
                name: 'firmwareVersion',
                customSort: tools.sortVersion
            }
        ];
    });

    renderSDM20LHT() {
        const { SDM20LHTs, profile } = this.props;

        return (
            <FHETable
                idTable="userDetailSDM20LHT"
                columns={this.renderColumns(profile)}
                data={this.renderData(SDM20LHTs)}
                actions={this.renderActions(profile)}
                rowDetail={this.renderDetails()}
                minified
            />
        );
    }

    render() {
        const { SDM20LHTs } = this.props;
        return (
            <Fragment>
                {SDM20LHTs.size > 0 ? this.renderSDM20LHT() : Translator.translate(`general.products.SDM20LHT.table.body.emptyDataSourceMessage`)}
            </Fragment>
        );
    }
}

function mapStateToProps(state, props) {
    const { history } = props;
    const userId = props.match.params.userId;
    const users = state.environments[history.environment].data.Users.get('list');
    const actualUser = users.getIn([userId], new Map());
    let SDM20LHTs = state.environments[history.environment].data.SDM20LHT.get('list')
        .filter(SDM20LHT => {
            return SDM20LHT.getIn(['usersList'], []).indexOf(parseInt(userId)) !== -1;
        })
        .map(SDM20LHT => {
            const masterUser = users.getIn([SDM20LHT.getIn(['userMasterId'], '').toString()], new Map());
            let otherUsers = [];
            const usersList = SDM20LHT.getIn(['usersList'], [])
                .map(_userId => {
                    const _user = users.getIn([_userId.toString()], new Map());
                    if (parseInt(userId) !== _user.get('_id'))
                        otherUsers.push({ id: _user.get('_id'), label: `${_user.get('firstname')} ${_user.get('lastname')}` });
                    return _user;
                })
                .sort(a => {
                    if (a.get('_id') === SDM20LHT.get('userMasterId')) return -1;
                    else return 1;
                });
            return SDM20LHT.set('userEmail', masterUser.get('email'))
                .set('usersList', usersList)
                .set('otherUsers', otherUsers);
        });
    return {
        profile: state.data.user,
        user: actualUser,
        users,
        SDM20LHTs
    };
}

const styles = theme => ({
    detailPanelHeader: {
        color: theme.palette.text.secondary
    },
    masterRow: {
        backgroundColor: theme.palette.primary.light,
        color: theme.palette.primary.dark
    },
    userRow: {
        backgroundColor: 'white',
        color: theme.palette.text.secondary
    },
    connected: {
        color: theme.palette.success.main
    },
    disconnected: {
        color: theme.palette.error.main
    }
});

export default withRouter(
    connect(
        mapStateToProps,
        dispatch => bindActionCreators(Object.assign({}, { dissociateSDM20LHTUser, dissociateSDM20LHTUserAndSwitchMaster }), dispatch)
    )(withStyles(styles, { withTheme: true })(TableSDM20LHT))
);



// WEBPACK FOOTER //
// ./environments/myfhe/scenes/User/Table/TableSDM20LHT.js